import React, { useMemo } from 'react';
import { Container, Row, Col, Card, Button, Alert } from 'react-bootstrap';
import { 
  IconRocket, 
  IconSettings, 
  IconUsers, 
  IconBolt,
  IconMessage
} from '@tabler/icons-react';
import './AgentCreator.css';

const AgentTypeSelector = ({ onSelectType }) => {
  const isMobile = useMemo(() => window.innerWidth <= 768, []);

  return (
    <Container className="py-5">
      <div className="text-center mb-5">
        <h2 className="mb-3">Criar Novo Agente de IA</h2>
        <p className="text-muted">
          Escolha o tipo de agente que melhor atende às suas necessidades
        </p>
      </div>

      {isMobile && (
        <Alert variant="info" className="mb-4 text-center">
          <p className="mb-0">
            📱 <strong>Versão Mobile:</strong> Para criar agentes avançados com
            configurações completas, acesse a versão desktop
          </p>
        </Alert>
      )}

      <Row className="justify-content-center">
        {/*   <Col lg={4} md={6} className="mb-4">
          <Card className="h-100 agent-type-card shadow-sm hover-shadow">
            <Card.Body className="text-center p-4">
              <div className="mb-3">
                <div 
                  className="rounded-circle bg-primary bg-opacity-10 d-inline-flex align-items-center justify-content-center"
                  style={{ width: '80px', height: '80px' }}
                >
                  <IconBolt size={40} className="" />
                </div>
              </div>
              
              <h4 className="mb-3 text-primary">Agente Básico</h4>
              
              <p className="text-muted mb-4">
                Perfeito para começar! Crie um agente informativo rapidamente, 
                ideal para responder dúvidas sobre seu negócio de forma simples e eficiente.
              </p>

              <div className="mb-4">
                <small className="text-muted d-block mb-2">✅ Ideal para:</small>
                <ul className="list-unstyled text-start small">
                  <li>• Usuários iniciantes</li>
                  <li>• Agentes informativos simples</li>
                  <li>• FAQ inteligente</li>
                  <li>• Configuração em 2 minutos</li>
                </ul>
              </div>

              <Button 
                variant="primary" 
                size="lg" 
                className="w-100"
                onClick={() => onSelectType('basic')}
              >
                <IconBolt className="me-2" size={18} />
                Criar Agente Básico
              </Button>
            </Card.Body>
          </Card>
        </Col> */}

        {!isMobile && (
          <Col md={6} className="mb-4">
            <Card className="h-100 agent-type-card shadow-sm hover-shadow">
              <Card.Body className="text-center p-4">
                <div className="mb-3">
                  <div
                    className="rounded-circle bg-primary bg-opacity-10 d-inline-flex align-items-center justify-content-center"
                    style={{ width: "80px", height: "80px" }}
                  >
                    <IconBolt size={40} className="" />
                  </div>
                </div>

                <h4 className="mb-3 text-primary">Agente por etapas</h4>

                <p className="text-muted mb-4">
                  Controle total! Configure fluxos personalizados, funções
                  especiais, processos de qualificação e automações complexas.
                </p>

                <div className="mb-4">
                  <small className="text-muted d-block mb-2">⚡ Inclui:</small>
                  <ul className="list-unstyled text-start small">
                    <li>• Fluxos de conversação customizados</li>
                    <li>• Funções e integrações</li>
                    <li>• Processos de qualificação</li>
                    <li>• Configurações avançadas</li>
                  </ul>
                </div>

                <Button
                  variant="primary"
                  size="lg"
                  className="w-100"
                  onClick={() => onSelectType("advanced")}
                >
                  <IconSettings className="me-2" size={18} />
                  Criar Agente por etapas
                </Button>
              </Card.Body>
            </Card>
          </Col>
        )}

        <Col md={6} className="mb-4">
          <Card className="h-100 agent-type-card shadow-sm hover-shadow">
            <Card.Body className="text-center p-4">
              <div className="mb-3">
                <div
                  className="rounded-circle bg-success bg-opacity-10 d-inline-flex align-items-center justify-content-center"
                  style={{ width: "80px", height: "80px" }}
                >
                  <IconMessage size={40} className="" />
                </div>
              </div>

              <h4 className="mb-3 text-success">Agente por Prompt</h4>

              <p className="text-muted mb-4">
                Máxima flexibilidade! Descreva seu agente ideal em texto livre e
                deixe a IA criar tudo para você de forma automática e
                personalizada.
              </p>

              <div className="mb-4">
                <small className="text-muted d-block mb-2">
                  🚀 Ideal para:
                </small>
                <ul className="list-unstyled text-start small">
                  <li>• Usuários experientes</li>
                  <li>• Agentes altamente customizados</li>
                  <li>• Criação rápida via IA</li>
                  <li>• Máxima personalização</li>
                </ul>
              </div>

              <Button
                variant="success"
                size="lg"
                className="w-100"
                onClick={() => onSelectType("prompt")}
              >
                <IconMessage className="me-2" size={18} />
                Criar por Prompt
              </Button>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default AgentTypeSelector;